/* Generated by tools/build-localization.mjs. Do not edit by hand. */
const el = {
  "about.body": "Είμαστε μια ομάδα φίλων που ξεκίνησαν να ερευνούν τα αρχαία και γιγάντια δέντρα της Κύπρου, και στη συνέχεια ταξίδεψαν σε όλο το νησί για να τα βρουν και να τα φωτογραφίσουν. Αυτός ο κατάλογος συγκεντρώνει αυτήν την εργασία.",
  "about.corrections": "Εντοπίσατε κάποιο λάθος ή γνωρίζετε ένα δέντρο που λείπει από τον κατάλογό μας; Γράψτε μας το όνομα και την τοποθεσία του, τη διόρθωση ή την πρότασή σας και, αν μπορείτε, στείλτε φωτογραφίες ή σύνδεσμο σε μια πηγή.",
  "about.licensing": "Οι φωτογραφίες μας πιστώνονται στην ομάδα Cyprus Trees. Εξωτερικές φωτογραφίες συνδέονται με τη σελίδα όπου βρέθηκαν, και κάθε καταγραφή δέντρου διατηρεί τις πηγές της έρευνάς της.",
  "about.title": "Σχετικά με το έργο",
  "catalogue.empty": "Κανένα δέντρο δεν ταιριάζει με αυτά τα φίλτρα. Καθαρίστε τα φίλτρα για να δείτε τον πλήρη κατάλογο.",
  "catalogue.error": "Ο κατάλογος δεν μπόρεσε να φορτωθεί. Ελέγξτε τη σύνδεσή σας και φορτώστε ξανά τη σελίδα.",
  "catalogue.filter.age": "Ηλικία",
  "catalogue.filter.ageAny": "Οποιαδήποτε ηλικία",
  "catalogue.filter.ageBand": "{{from}}–{{to}} χρόνια",
  "catalogue.filter.ageOldest": "1000 χρόνια και άνω",
  "catalogue.filter.ageUnrecorded": "Δεν υπάρχει καταγεγραμμένη ηλικία",
  "catalogue.filter.apply": "Εμφάνιση: {{count}}",
  "catalogue.filter.clear": "Καθαρισμός φίλτρων",
  "catalogue.filter.close": "Κλείσιμο φίλτρων",
  "catalogue.filter.done": "Τέλος",
  "catalogue.filter.filters": "Φίλτρα",
  "catalogue.filter.maxAge": "Έως, έτη",
  "catalogue.filter.minAge": "Από, έτη",
  "catalogue.filter.noSpecies": "Δεν βρέθηκαν είδη",
  "catalogue.filter.onlyUnknownAge": "Μόνο δέντρα άγνωστης ηλικίας",
  "catalogue.filter.remove": "Αφαίρεση: {{label}}",
  "catalogue.filter.search": "Αναζήτηση με όνομα, είδος ή χωριό",
  "catalogue.filter.searchSpecies": "Αναζήτηση είδους",
  "catalogue.filter.selected": "Επιλεγμένα: {{count}}",
  "catalogue.filter.shortSearch": "Αναζήτηση δέντρου",
  "catalogue.filter.species": "Είδη",
  "catalogue.filter.speciesAny": "Όλα τα είδη",
  "catalogue.results": "Δέντρα: {{count}}",
  "catalogue.title": "Δέντρα",
  "copy.action": "Αντιγραφή: {{label}}",
  "copy.failure": "Η αντιγραφή απέτυχε. Επιλέξτε και αντιγράψτε το κείμενο.",
  "copy.success": "Αντιγράφηκε: {{label}}",
  "count.catalogue": "Δέντρα στον κατάλογο",
  "district.famagusta": "Αμμόχωστος",
  "district.kyrenia": "Κερύνεια",
  "district.larnaca": "Λάρνακα",
  "district.limassol": "Λεμεσός",
  "district.nicosia": "Λευκωσία",
  "district.paphos": "Πάφος",
  "footer.navigation": "Πλοήγηση υποσέλιδου",
  "footer.note": "Ένας κατάλογος φτιαγμένος από μια ομάδα φίλων που ταξιδεύουν στην Κύπρο.",
  "gallery.close": "Κλείσιμο γκαλερί",
  "gallery.next": "Επόμενο",
  "gallery.openPhoto": "Άνοιγμα φωτογραφίας {{index}} από {{total}}",
  "gallery.position": "{{index}} από {{total}}",
  "gallery.previous": "Προηγούμενο",
  "gallery.title": "Φωτογραφίες δέντρων",
  "gallery.viewAll": "Προβολή όλων των {{count}}",
  "hero.body": "Ένας αναπτυσσόμενος κατάλογος και χάρτης αξιόλογων παλιών δέντρων σε όλη την Κύπρο, που συγκεντρώθηκε από δημοσιευμένες πηγές και τα ταξίδια μας στο νησί.",
  "hero.title": "Αρχαία Δέντρα της Κύπρου",
  "language.switch": "Γλώσσα",
  "location.hint": "Η ομάδα μας δεν έχει επιβεβαιώσει ακόμη ότι αυτό το δέντρο βρίσκεται ακριβώς εδώ.",
  "location.uncertain": "Θέση;",
  "location.unknown": "Άγνωστη τοποθεσία",
  "map.attribution": "© Συνεργάτες του OpenStreetMap",
  "map.listTitle": "Δέντρα στον χάρτη",
  "map.title": "Χάρτης δέντρων",
  "meta.catalogueDescription": "Περιηγηθείτε σε {{count}} αρχαία, γιγάντια και αξιόλογα δέντρα σε όλη την Κύπρο ανά είδος και ηλικία, με φωτογραφίες, τοποθεσίες και περιγραφές βασισμένες σε πηγές.",
  "meta.homeDescription": "Εξερευνήστε αρχαία, γιγάντια και αξιόλογα δέντρα σε όλη την Κύπρο σε έναν πολύγλωσσο επιτόπιο κατάλογο με φωτογραφίες, ερευνητικές πηγές και έναν διαδραστικό χάρτη.",
  "meta.imageAlt": "Έμβλημα «Μνημειακά Δέντρα Κύπρου» — ένα ζωγραφισμένο στο χέρι ελαιόδεντρο με το περίγραμμα της Κύπρου",
  "meta.mapDescription": "Βρείτε αρχαία, γιγάντια και αξιόλογα δέντρα σε όλη την Κύπρο σε έναν διαδραστικό χάρτη, με φωτογραφίες και σαφώς σημειωμένα μη επαληθευμένα σημεία.",
  "meta.treeDescription": "Εξερευνήστε {{name}} κοντά στην {{place}}, με φωτογραφίες, λεπτομέρειες τοποθεσίας και ερευνητικές πηγές από τον κατάλογο Ancient Trees of Cyprus.",
  "nav.catalogue": "Δέντρα",
  "nav.map": "Χάρτης",
  "nav.primary": "Κύρια πλοήγηση",
  "notFound.page": "Αυτή η σελίδα δεν βρέθηκε. Επιστρέψτε στον κατάλογο δέντρων.",
  "photo.creditTeam": "© Ομάδα Cyprus Trees",
  "photo.creditVia": "Πηγή φωτογραφίας: {{host}}",
  "photo.pending": "Δεν έχουμε ακόμη φωτογραφία για αυτό το δέντρο.",
  "photo.unavailable": "Φωτογραφία μη διαθέσιμη",
  "plaque.age": "Ηλικία",
  "plaque.coordinates": "Συντεταγμένες",
  "plaque.district": "Επαρχία",
  "plaque.girth": "Περίμετρος",
  "plaque.height": "Ύψος",
  "plaque.meters": "μ.",
  "plaque.protection": "Προστασία",
  "plaque.protectionMonument": "Μνημείο φύσης",
  "plaque.species": "Είδος",
  "plaque.title": "Στοιχεία",
  "plaque.unknown": "Άγνωστο",
  "plaque.village": "Χωριό",
  "rule.label": "Ηλικία κάθε τεκμηριωμένου δέντρου",
  "rule.none": "Άγνωστη ηλικία",
  "sheet.access": "Πρόσβαση",
  "sheet.funFacts": "Λεπτομέρειες",
  "sheet.mapsLink": "Άνοιγμα στους Χάρτες Google",
  "sheet.notFound": "Αυτό το δέντρο δεν υπάρχει στον κατάλογο. Ίσως έχει αφαιρεθεί, συγχωνευθεί με άλλη καταγραφή ή συνδεθεί λανθασμένα.",
  "sheet.sources": "Πηγές",
  "sheet.sourcesOwnFieldwork": "Αυτή η καταγραφή προέρχεται από τις φωτογραφίες πεδίου και τις συντεταγμένες μας· δεν αναφέρεται ξεχωριστή δημοσιευμένη πηγή.",
  "sheet.whereItStands": "Τοποθεσία",
  "site.title": "Αρχαία Δέντρα της Κύπρου",
  "species.calabrianPine": "Τραχεία πεύκη",
  "species.carob": "Χαρουπιά",
  "species.cypress": "Κυπαρίσσι",
  "species.ficus": "Φίκος",
  "species.goldenOak": "Λατζιά",
  "species.grapevine": "Άμπελος",
  "species.juniper": "Άρκευθος",
  "species.kermesOak": "Πουρνάρι",
  "species.laurel": "Δάφνη",
  "species.multiple": "Διάφορα είδη",
  "species.oak": "Βελανιδιά",
  "species.olive": "Ελιά",
  "species.other": "Άλλα είδη",
  "species.pine": "Μαύρη πεύκη",
  "species.pineUnspecified": "Πεύκο",
  "species.plane": "Ανατολικός πλάτανος",
  "species.planeUnspecified": "Πλάτανος",
  "species.stonePine": "Κουκουναριά",
  "species.strawberryTree": "Κουμαριά",
  "species.sycomoreFig": "Συκομορέα",
  "species.terebinth": "Τερέβινθος",
  "species.tipuana": "Τιπουάνα",
  "theme.dark": "Σκούρο",
  "theme.light": "Φωτεινό",
  "theme.toDark": "Μετάβαση σε σκούρο θέμα",
  "theme.toLight": "Μετάβαση σε φωτεινό θέμα",
  "tree.ageLabel": "Ηλικία: {{label}} έτη",
  "tree.ageYears": "{{count}} ετών",
  "tree.backToLedger": "Επιστροφή σε όλα τα δέντρα",
  "tree.name": "Όνομα",
  "tree.speciesUnrecorded": "Είδος ακαταχώριστο",
  "visit.hint": "Η ομάδα μας δεν έχει επισκεφθεί ακόμη αυτό το δέντρο ούτε έχει τραβήξει δικές της φωτογραφίες εδώ.",
  "visit.notVisited": "Χωρίς επίσκεψη",
} as const;

export default el;
